import { useFlags } from 'launchdarkly-react-client-sdk';
import { BannerContainer, BannerContent, BannerSpacer, BannerText } from './styles';

interface PlaylistDeadlineWarningBannerProps {
  hasActiveDeadlines: boolean;
  visible: boolean;
}

const PlaylistDeadlineWarningBanner = ({
  hasActiveDeadlines,
  visible,
}: PlaylistDeadlineWarningBannerProps): JSX.Element | null => {
  const { playlistDeadlinesMvp } = useFlags() || {};
  const isDeadlineWarningEnabled = playlistDeadlinesMvp === true;

  if (!isDeadlineWarningEnabled || !hasActiveDeadlines || !visible) {
    return null;
  }

  return (
    <>
      <BannerSpacer />
      <BannerContainer
        role="alert"
        aria-live="polite"
        data-testid="playlist-deadline-warning-banner"
      >
        <BannerContent>
          <BannerText>
            <strong>Playlist duration changed.</strong> Review all deadlines to ensure they are
            still appropriate.
          </BannerText>
        </BannerContent>
      </BannerContainer>
    </>
  );
};

export default PlaylistDeadlineWarningBanner;
